module.exports = __webpack_public_path__ + "img/18.875575f9.png";